// extracted by mini-css-extract-plugin
module.exports = {"logoBar":"logoBar-module--logoBar--_nHYR","slide":"logoBar-module--slide--3RBLP","logo":"logoBar-module--logo--1lb7R"};